import { Debug } from '@svt/debug';
import { supportsLocalStorage } from './environment';
import { migratePayload } from './persistentStateMigration';

const { error } = Debug('play:loadPersistentActions:error');

export const LOCAL_STORAGE_KEY = 'persistent_state_v2';

export const loadPersistentActions = (
    dispatch: ({ type: string, payload: any }) => void,
    typeToDispatch?: string
): void => {
    if (!supportsLocalStorage()) {
        return;
    }

    try {
        // Load actions from local storage and execute them
        const actions = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');

        Object.keys(actions).forEach((type) => {
            if (!typeToDispatch || typeToDispatch === type) {
                const payload = migratePayload(type, actions[type]);

                dispatch({ type, ...payload });
            }
        });

        dispatch({ type: 'PERSISTENT_STATE_LOADED', payload: true });
    } catch (err) {
        error('Error while reading data from localStorage: %s', err.message);
    }
};
